import React, { Component } from 'react'

export default class Definitions extends Component {
  render() {
    const {words} = this.props;
    return (
      <div>
        {words.map((w) =><div className="card text-white bg-light mb-3 text-muted m-auto" style={{maxWidth: '36rem'}}>
                            
                            <div className="card-body">
                                <div className='d-flex align-items-center mb-3'>
                                    <div className='pronunciations d-inline'>
                                    {w.pronunciations.map(pron=>{
                                        const audioId = `pron-${w.word}-${pron.accent}`;
                                        return<div className='d-inline'>
                                        <audio style={{opacity:0}} id={audioId} src={pron.file}></audio>
                                        <button className='btn p-0' onClick={()=>{document.getElementById(audioId).play()}}>
<svg
   xmlns="http://www.w3.org/2000/svg"
   id="svg8"
   version="1.1"
   viewBox="18 19 35 35"
   height="32px"
   width="32px">
  <defs
     id="defs2" />
  <g
     id="layer1">
    <circle
       r="16"
       cy="36.260414"
       cx="35.07143"
       id="path10"
       style={{fill:'none',strokeWidth:1.32291667,stroke:'#4d4d4d'}} />
    <path
       d="m 44.731651,36.257809 -7.44948,4.300959 -7.44948,4.300959 0,-8.601919 0,-8.601918 7.44948,4.300959 z"
       id="path817"
       style={{fill:'none',strokeWidth:1.32291667,stroke:'#4d4d4d'}} />
  </g>
</svg>
</button>
                                    </div>})}
                                    </div>
                                    <span className='h4 px-2 me-2 mb-0 border-end border-2'>{w.word}</span>
                                    <div className='phonetics d-inline'>
                                       {w.pronunciations.map(pron=>`/${pron.phonetics}/`).join(', ')}
                                    </div>
                                </div>
                                <div className='rounded bg-white py-1'>
                                    {w.definitions.map((d,i)=><div className={`def-wrap bg-white ${i===0 ? 'pt-4':'pt-2'} pb-2`}><p className='ps-2 word-definition'><strong>Definition: </strong><i>{d.text}</i></p></div>)}
                                </div>
                                
                        </div></div>)}
      </div>
    )
  }
}
